import {
  AlertLayer,
  Breakpoints,
  ContainerGutter,
  styled,
  TextTag,
} from '@volkswagen-onehub/components-core';
import { Close } from '@vw-marketing/us-components';
import React from 'react';
import { Box, TextBox } from '../Box';
import {
  TextAppearance,
  TextLineHeight,
  TextSize,
  TextWeight,
} from '@vw-marketing/us-components';
import { IconButton } from '../Button/IconButton';
import { LayerBox, ContainerBox } from '../Box';

interface AlertMessageProps {
  title?: string;
  message: string;
  onClose: () => void;
}

const AbsolutePositionWrapper = styled.div`
  position: absolute;
  top: 10%;
  left: 50%;
  transform: translateX(-50%);
`;

export const AlertMessage = ({
  title,
  message = '',
  onClose,
}: AlertMessageProps) => {
  return (
    <LayerBox style={{ zIndex: 9999 }}>
      <AbsolutePositionWrapper>
        <AlertLayer active>
          <ContainerBox
            style={(theme) => ({
              padding: `${theme.size.static250} ${theme.size.static450} ${theme.size.static450} ${theme.size.static450}`,
            })}
            stretchContent
          >
            <ContainerBox
              gutter={ContainerGutter.static200}
              wrap='always'
              style={{ position: 'relative' }}
            >
              <Box
                style={{
                  position: 'absolute',
                  right: 0,
                }}
              >
                <IconButton
                  icon={<Close />}
                  onClick={onClose}
                  ariaLabel="Close"
                  style={(theme) => ({
                    color: theme.colors.content.onsurface,
                  })}
                />
              </Box>

              {title && (
                <TextBox
                  appearance={TextAppearance.headline500}
                  tag={TextTag.h2}
                  style={{
                    [Breakpoints.default]: {
                      fontSize: TextSize.TextSize20,
                      fontWeight: TextWeight.bold,
                      lineHeight: TextLineHeight.TextLineHeight28,
                    },
                  }}
                  customStyle={(theme) => ({
                    color: theme.colors.content.onsurface,
                  })}
                >
                  {title}
                </TextBox>
              )}
              <TextBox
                appearance={TextAppearance.copy200}
                tag={TextTag.p}
                style={{
                  [Breakpoints.default]: {
                    fontSize: TextSize.TextSize16,
                    fontWeight: TextWeight.regular,
                    lineHeight: TextLineHeight.TextLineHeight24,
                  },
                }}
                customStyle={(theme) => ({
                  color: theme.colors.content.onsurface,
                })}
              >
                {message}
              </TextBox>
            </ContainerBox>
          </ContainerBox>
        </AlertLayer>
      </AbsolutePositionWrapper>
    </LayerBox>
  );
};
